import LogService from './logService'

export class KeywordsService {

  keywords = [{
    key: 'variable',
    instances: [],
    regex: '{[ ]*variable:[ ]*([a-z0-9._-]*)[ ]*}'
  },
  {
    key: 'child',
    instances: [],
    regex: '{[ ]*child:[ ]*([a-z0-9._-]*)[ ]*}'
  },
  {
    key: 'rate',
    instances: [],
    regex: '{[ ]*rate:[ ]*{[]*([a-z0-9._,: \']*)[ ]*}[ ]*}'
  },
  {
    key: 'rateEffectiveDate',
    instances: [],
    regex: '{[ ]*rateEffectiveDate:[ ]*{[]*([a-z0-9._,: \']*)[ ]*}[ ]*}'
  }]

  constructor(content, disclosure, client) {
    this.content = content
    this.disclosure = disclosure
    this.client = client

    this.initializeKeywords(this.content)
  }

  initializeKeywords = () => {
    this.keywords.forEach(keyword => {
      const variablesRegexp = new RegExp(keyword.regex, 'gi')
      let instances = [],
        result = null

      while ((result = variablesRegexp.exec(this.content)) !== null) {
        instances.push({fullMatch: result[0], groupMatch: result[1]})
      }

      keyword.instances = instances
    })
  }

  renderRates = () => {
    const rateKeywords = this.keywords.find(v => v.key === 'rate'),
      rateEffectiveDateKeywords = this.keywords.find(v => v.key === 'rateEffectiveDate')

    rateKeywords.instances.forEach(rate => {
      const rateFilter = rate.groupMatch.replace(/[ ]*:[ ]*/g, '={').replace(/[ ]*,[ ]*/g, '} ')+'}'

      this.content = this.content.replace(rate.fullMatch, `<Rate graphql ${rateFilter} />`)
    })

    rateEffectiveDateKeywords.instances.forEach(rate => {
      const rateFilter = rate.groupMatch.replace(/[ ]*:[ ]*/g, '={').replace(/[ ]*,[ ]*/g, '} ')+'}'

      this.content = this.content.replace(rate.fullMatch, `<EffectiveDate graphql ${rateFilter} />`)
    })

    return this
  }

  renderVariables = variables => {
    const variableKeywords = this.keywords.find(v => v.key === 'variable')

    variableKeywords.instances.forEach(variable => {
      /* Get the second part of a variable markdown. Example: it returns 'user.first_name' from
      * {variable: user.first_name} */
      const variableName = variable.groupMatch

      if (!variables[variableName]) {
        this.content = this.content.replace(variable.fullMatch, '')

        const error = `[Disclosures SDK] Variable '${variableName}' is not defined in the application and the disclosure '${this.disclosure.slug}' could not be rendered properly.`

        LogService.error(this.client, error, this.disclosure.uuid)
      } else {
        this.content = this.content.replace(variable.fullMatch, variables[variableName])
      }
    })

    return this
  }

  renderChildren = () => {
    const childrenKeywords = this.keywords.find(v => v.key === 'child')

    childrenKeywords.instances.forEach(child => {
      /* Get the second part of a child markdown. Example: it returns 'prequal.user' from
      * {child: prequal.user} */
      const childSlug = child.groupMatch

      this.content = this.content.replace(child.fullMatch, `<Disclosure slug="${childSlug}" child={true} name="${childSlug}" actions={actions}/>`)
    })

    return this
  }
}
